export * from './simple-address-input.component';
